import algoliasearch from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js';
import { searchBox, hits, hitsPerPage, index, stats } from 'instantsearch.js/es/widgets';

const searchClient = algoliasearch(window.algoliaAppId, window.algoliaApiKey);

const search = instantsearch({
	indexName: window.algoliaIndex,
	searchClient,
	routing: true,
	searchFunction(helper) {
		if (helper.state.query === '') {
			// console.log('dont search');
			$('.search-popup-section #hits').hide();
			$('.search-popup-section #hits-products').hide();
			$('.search-popup-section .column-hits-products .heading').hide();
			$('.search-popup-section .column-hits .heading').hide();
			$('#searchbox .ais-SearchBox-reset').hide();
			return;
		}
		$('.search-popup-section .column-hits-products .heading').show();
		$('.search-popup-section .column-hits .heading').show();
		$('#hits').show();
		$('#hits-products').show();
		$('#searchbox .ais-SearchBox-reset').show();
		helper.search();
	}
});


search.addWidgets([

    searchBox({
        container: '#searchbox',
		placeholder: 'Start typing to search',
		clear: false,
		queryHook(query, search) {
			search(query);
		},
		templates: {

		},
    }),

	hitsPerPage({
		container: '#hits-per-page',
		items: [
			{ label: '16 hits per page', value: 16, default: true },
		],
	}),

    hits({
		container: '#hits',
		templates: {
			item(hit, { html, components, sendEvent }) {
				return "<a href='" + hit.url + "'>" + hit.title + "</a>";
			},
		},
    }),
	
	index({ indexName: window.algoliaIndexShop }).addWidgets([
		hits({
			container: '#hits-products',
			templates: {
				item(hit, { html, components, sendEvent }) {
					var productHtml = hit.html;
				
					// Create a temporary DOM element
					const wrapper = document.createElement('div');
					wrapper.innerHTML = productHtml;
				
					// Modify attributes
					const overlayLink = wrapper.querySelector('.overlay-link');
					if (overlayLink) {
						// Append the form
						overlayLink.insertAdjacentHTML('afterend', `
							<form method="post" class="cart-update">
								<input type="hidden" name="action" value="commerce/cart/update-cart">
								<input type="hidden" name="purchasableId" value="${hit.purchasableId}">
								<input type="hidden" name="qty" step="1" value="1" min="0">
								<button data-add-to-cart-button="mini" class="btn btn-yellow btn-fill btn-keyword-small">
									<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
									<g transform="translate(-1494.5 -1003.5)">
									<line y2="14" transform="translate(1501.5 1003.5)" fill="none" stroke="#000" stroke-width="2"></line>
									<line y2="14" transform="translate(1508.5 1010.5) rotate(90)" fill="none" stroke="#000" stroke-width="2"></line>
									</g>
									</svg>
								</button>
							</form>
						`);
					}
				
					// Update theme and button classes
					wrapper.querySelectorAll('[data-theme="white"]').forEach(el => {
						el.setAttribute('data-theme', 'black');
						el.setAttribute('data-cart', 'true');
					});
					wrapper.querySelectorAll('.btn-transparent').forEach(el => {
						el.classList.replace('btn-transparent', 'btn-transparent-white');
					});
				
					return wrapper.innerHTML;
				},
			},
		}),
		hitsPerPage({
			container: '#hits-per-page-products',
			items: [
				{ label: '6 hits per page', value: 6, default: true },
			],
		}),
	]),

]);

search.start();

search.on('render', function() {
	setTimeout(() => {
		resizeVideo();
	}, 1000);


	var productEl = $('[data-product-id]');
	if (productEl.length) {
		productEl.each(async function() {
			var productId = $(this).attr('data-product-id');
			checkStock(productId);
		})
	}	
});
